import React from 'react';
import { NavLink } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import RightsCheck from '../General/RightsCheck';
import { scrollToTop } from '../Shared/ScrollOnTop';

function FeeSystemMenu(props) {
    return (
        <>
            <RightsCheck />
            <nav className={`navbar navbar-expand-lg navbar-module MenuSticky`}>
                <div className="container-fluid">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#NavbarSecondary"
                        aria-controls="NavbarSecondary"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="NavbarSecondary">
                        <ul className="navbar-nav m-auto">
                            <li className="nav-item">
                                <NavDropdown title="Fee Vouchers">
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/PrintVouchers">Print Vouchers</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/GenerateChallan">Generate New Voucher</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/DeletedVouchers">Deleted Vouchers</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/StudentsMissingVoucher">Students Missing Voucher</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/ChallanCorrector">Challan Corrector</NavLink>
                                </NavDropdown>
                            </li>
                            <li className="nav-item">
                                <NavDropdown title="Advance">
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/GenerateAdvanceChallan">Generate Advance Challan</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/DuplicatePaymentReceived">Duplicate Payment Received</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/AdvanceAmountReport">Advance Amount Report</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/AdvanceAdjustedInMonthReport">Advance Adjusted in Month</NavLink>
                                </NavDropdown>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/FeeSystem/AddAbsentFine">Add Absent Fine</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/FeeSystem/AddOtherDuesFine">Add Other Dues/Fine</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/FeeSystem/AddBankScroll">Add Bank Scroll</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/FeeSystem/ChangeScrollDate">Change Scroll Date</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavDropdown title="Collections">
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/CollectionReport">Collection Report</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/CollectionReportHeadWise">Collection Report Headwise</NavLink>
                                    <NavLink onClick={scrollToTop} className="dropdown-item" to="/FeeSystem/DateWiseCollectionReport">DateWise Collection</NavLink>
                                </NavDropdown>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/FeeSystem/ChangeStudentStatus">Change Student Status</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default FeeSystemMenu;